import { useTranslation } from 'react-i18next';

const LawyerBillingStatus = () => {
  const { t } = useTranslation();
  const lawyerBilling = {
    totalReceived: 5000,
    status: "Fully Paid",
    released: true,
  };

  return (
    <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-sm p-6">
      <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        {t('Lawyer Payout Summary')}
      </h2>

      <dl className="text-sm text-gray-700 dark:text-gray-300 space-y-4">
        <div className="flex justify-between">
          <dt className="font-medium">{t('Total Received')}</dt>
          <dd>${lawyerBilling.totalReceived.toLocaleString()}</dd>
        </div>

        <div className="flex justify-between">
          <dt className="font-medium">{t('Status')}</dt>
          <dd>
            <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300">
              {t(lawyerBilling.status)}
            </span>
          </dd>
        </div>

        <div className="flex justify-between">
          <dt className="font-medium">{t('Payout Released')}</dt>
          <dd>
            {lawyerBilling.released ? (
              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300">
                {t('Yes')}
              </span>
            ) : (
              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300">
                {t('No')}
              </span>
            )}
          </dd>
        </div>
      </dl>
    </div>
  );
};

export default LawyerBillingStatus;
